import League from "model/League";
import {fetchApiClient} from "common/fetchApiClient";
import {AxiosError} from "axios";


const getMemberships = async (token: string | undefined): Promise<League[]> => {
    const apiClient = fetchApiClient(token);

    return await apiClient.get<League[]>(`/memberships`)
        .then(response => {
            return response.data;
        }).catch((error: AxiosError) => {
            // 403 is already mapped to UnauthorizedError by the axios response
            // interceptor in fetchApiClient. Everything else just propagates.
            console.log("Error when fetching memberships", error);
            throw error;
        });
}

export default getMemberships;
